<template>
    <div :class="cssStyle">
    </div>
</template>

<script>
    // import VTitle from 'v-title';

    export default {
        name: 'Cover',
        props: ['element','show'
        ],
        computed:{
            cssStyle:function () {
                if(this.show){
                    return 'cover active';
                }
                return 'cover';
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .cover.active{
        display:block;

    }
    .cover {
        display:none;
        width:100%;
        height:100%;
        position:fixed;
        top:0px;
        left:0px;
        color:RGBA(245,255,255,0.5);
        cursor:pointer;
    }
</style>
